import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Button, Dropdown, Menu, Modal } from "antd";
import QueueAnim from "rc-queue-anim";

import moment from "moment";

import { generalActions } from "./../../redux/actions";

import { logService } from "./../../redux/services";

import {
	UIAvatarLabel,
	UIPageListing,
} from "./../../components";

import ModalShow from "./show";
import ModalFilters from "./filters";

const config = {
	title            : "Logs de Alteração",
	subtitle         : "Acompanhe todas as alterações realizadas no sistema.",
	icon             : <i className="fal fa-history" />,
	infoBanner       : {
		icon       : <i className="fal fa-info-circle" />,
		title      : "Sobre os logs de alteração",
		description: "Os logs registram as inclusões, alterações e exclusões feitas no sistema, com o usuário responsável e a data de cada ação.",
	},
	permissionPrefix : "log",
	list             : "log",
	searchPlaceholder: "Buscar por mensagem, usuário ou item",
	orders           : [
		{
			label  : "Mais recentes",
			field  : "id",
			sort   : "desc",
			default: true,
		},
		{
			label: "Mais antigos",
			field: "id",
			sort : "asc",
		},
		{
			label: "Mensagem A|Z",
			field: "message",
			sort : "asc",
		},
		{
			label: "Mensagem Z|A",
			field: "message",
			sort : "desc",
		},
	],
};

const ACTION_ICONS = [
	["store", "fal fa-plus-circle"],
	["update", "fal fa-edit"],
	["destroy", "fal fa-trash-alt"],
	["export", "fal fa-file-export"],
	["cartao", "fal fa-clock"],
];

/**
 * @param {Object} item
 *
 * @returns {string}
 */
const actionIcon = (item) => {
	const action = String(item.action || "");

	if( action !== "account" )
	{
		const icon = ACTION_ICONS.find(([prefix]) => action.startsWith(prefix));

		return icon ? icon[1] : "fal fa-history";
	}

	const message = String(item.message || "").toLowerCase();

	if( message.includes("login") ) return "fal fa-sign-in";
	if( /deslog|deslig/.test(message) ) return "fal fa-power-off";
	if( message.includes("empresa") ) return "fal fa-building";

	return "fal fa-user-shield";
};

class Index extends Component {
	constructor(props) {
		super(props);

		const defaultOrder = config.orders.find(o => o.default);

		this.filtersClean = {
			created_at: null,
			user_id   : null,
			action    : null,
			log_type  : null,
			method    : null,
		};

		this.state = {
			isLoading   : false,
			listType    : "list",
			data        : [],
			pagination  : {
				current : 1,
				pageSize: 20,
				total   : 0,
			},
			orderByLabel: defaultOrder.label,
			orderByField: defaultOrder.field,
			orderBySort : defaultOrder.sort,
			search      : "",
			// Actions
			showModalVisible   : false,
			filtersModalVisible: false,
			isExporting        : false,
			// Filters
			filters       : {
				...this.filtersClean,
			},
			filterOptions : {
				users  : [],
				actions: [],
				items  : [],
			},
			kpis          : null,
		};
	}

	static getDerivedStateFromProps(props, state) {
		if( props.listType && state.listType !== props.listType )
		{
			return {
				listType: props.listType
			};
		}

		return null;
	}

	componentDidMount() {
		// Fecth all
		this.fetchGetAll(true);

		// Filter options
		this.fetchFilterOptions();
	}

	menuItem = (item) => (
		<Menu className="actions-dropdown-menu">
			{this.props.permissions.includes(config.permissionPrefix + ".show") && <Menu.Item key="show">
				<a onClick={() => this.showOpen(item)}>
					<i className="fal fa-file" />Visualizar
				</a>
			</Menu.Item>}
		</Menu>
	);

	columns = () => {
		const listTypeCard = this.state.listType === "card";

		return [
			{
				title : "Mensagem",
				render: (item) => listTypeCard ? (
					<h3><i className={actionIcon(item)} style={{marginRight: 8}} />{item.message}</h3>
				) : (
					<UIAvatarLabel
						name={item.message}
						icon={<i className={actionIcon(item)} />}
						square
					/>
				),
			},
			{
				title : "Usuário",
				render: (item) => listTypeCard ? (
					<p><i className="fal fa-user" style={{marginRight: 5}} />{`${item.user_id} - ${item.user?.name || "-"}`}</p>
				) : (
					<UIAvatarLabel
						id={item.user_id}
						name={item.user?.name || "-"}
						icon={item.user_id}
					/>
				),
			},
			{
				title : "Item",
				render: (item) => {
					if( !item.log_id ) return "-";

					return item.log_name ? `${item.log_id} - ${item.log_name}` : String(item.log_id);
				},
			},
			{
				title    : "Data",
				className: "datetime card-block-width-2",
				render   : (item) => {
					if( listTypeCard )
					{
						return (
							<Fragment>
								<i className="fal fa-clock" style={{marginRight: 5}} />{moment(item.created_at).format("DD/MM/YYYY HH:mm")}
							</Fragment>
						);
					}

					return moment(item.created_at).format("DD/MM/YYYY HH:mm");
				},
			},
			{
				title    : "Ações",
				className: "actions no-ellipsis",
				visible  : this.props.permissions.includes(config.permissionPrefix + ".show"),
				render   : (item) => (
					<Dropdown overlay={this.menuItem(item)} className="actions-dropdown" placement="bottomRight" trigger={["click"]}>
						<Button icon={<i className="fal fa-ellipsis-v" />} />
					</Dropdown>
				),
			},
		];
	};

	fetchGetAll = (init = false, exportItems = false) => {
		const {pagination, orderByField, orderBySort, search, filters} = this.state;

		if( exportItems )
		{
			this.setState({
				isExporting: true,
			});
		}
		else
		{
			this.setState({
				isLoading: true,
			});
		}

		const data = {
			orderBy: `${orderByField}:${orderBySort}`,
			search : search,
		};

		if( exportItems )
		{
			data.exportItems = true;
		}
		else
		{
			data.page  = init ? 1 : pagination.current;
			data.limit = pagination.pageSize;
		}

		if( filters.created_at )
		{
			data.created_at = [
				filters.created_at[0].clone().startOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
				filters.created_at[1].clone().endOf("day").format("YYYY-MM-DDTHH:mm:ssZ")
			];
		}

		if( filters.user_id )
		{
			data.user_id = filters.user_id;
		}

		if( filters.action )
		{
			data.action = filters.action;
		}

		if( filters.log_type )
		{
			data.log_type = filters.log_type;
		}

		if( filters.method )
		{
			data.method = filters.method;
		}

		logService.getAll(data)
		.then((response) => {
			if( exportItems )
			{
				this.setState({
					isExporting: false,
				});

				window.open(response.data.file_url, "_blank");
			}
			else
			{
				this.setState(state => ({
					isLoading : false,
					data      : response.data.data,
					kpis      : response.data.kpis ?? null,
					pagination: {
						...state.pagination,
						current: response.data.meta.current_page,
						total  : response.data.meta.total,
					},
				}));
			}
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	fetchFilterOptions = () => {
		logService.getFilters()
		.then((response) => {
			this.setState({
				filterOptions: {
					users  : response.data.users || [],
					actions: response.data.actions || [],
					items  : response.data.items || [],
				},
			});
		})
		.catch(() => null);
	};

	onListTypeChange = (type) => {
		this.props.onChangeListType(type);
	};

	onPaginationChange = (page, pageSize) => {
		this.setState(state => ({
			pagination: {
				...state.pagination,
				current: page,
				pageSize,
			},
		}), () => {
			this.fetchGetAll();
		});
	};

	/**
	 * @param {string} value
	 */
	onOrderChange = (value) => {
		const defaultOrder = config.orders.find(o => `${o.field}:${o.sort}` === value);

		if( !defaultOrder ) return null;

		this.setState(state => ({
			orderByLabel: defaultOrder.label,
			orderByField: defaultOrder.field,
			orderBySort : defaultOrder.sort,
		}), () => {
			this.fetchGetAll(true);
		});
	};

	onSearch = (value) => {
		this.setState({
			search: value,
		}, () => {
			this.fetchGetAll(true);
		});
	};

	onSearchChange = (e) => {
		// If it does not have type then it's cleaning
		if( !e.hasOwnProperty("type") )
		{
			const {search} = this.state;

			this.setState({
				search: e.target.value,
			}, () => {
				if( search )
				{
					this.fetchGetAll(true);
				}
			});
		}
	};

	/**
	 * Show
	 *
	 * @param uuid
	 */
	showOpen = ({uuid}) => {
		this.setState({showModalVisible: true});

		// On open screen
		this.showScreen.onOpen(uuid);
	};

	showOnClose = () => {
		this.setState({showModalVisible: false});
	};

	/**
	 * Filter
	 */
	activeFiltersCount = () => {
		return Object.values(this.state.filters).filter(value => value !== null).length;
	};

	filtersOpen = () => {
		this.setState({filtersModalVisible: true});

		// On open screen
		this.filtersScreen.onOpen({...this.state.filters});
	};

	filtersOnClose = () => {
		this.setState({filtersModalVisible: false});
	};

	filtersOnComplete = (filters) => {
		this.setState({
			filtersModalVisible: false,
			filters            : filters,
		}, () => {
			this.fetchGetAll(true);
		});
	};

	render() {
		return (
			<QueueAnim className="site-content-inner">
				<div className="page-content fixed-header" key="1">
					<UIPageListing
						icon={config.icon}
						title={config.title}
						subtitle={config.subtitle}
						infoBanner={config.infoBanner}
						kpis={[
							{
								key    : "total",
								tone   : "blue",
								icon   : <i className="fal fa-history" />,
								title  : "Total de logs",
								value  : this.state.kpis?.total ?? "—",
								caption: "Alterações registradas",
							},
							{
								key    : "today",
								tone   : "green",
								icon   : <i className="fal fa-calendar-day" />,
								title  : "Hoje",
								value  : this.state.kpis?.hoje ?? "—",
								caption: "Alterações registradas hoje",
							},
							{
								key    : "lastSevenDays",
								tone   : "violet",
								icon   : <i className="fal fa-calendar-week" />,
								title  : "Últimos 7 dias",
								value  : this.state.kpis?.ultimos_7_dias ?? "—",
								caption: "Alterações na última semana",
							},
						]}
						onSearch={this.onSearch}
						onSearchChange={this.onSearchChange}
						onPaginationChange={this.onPaginationChange}
						onOrderChange={this.onOrderChange}
						onListTypeChange={this.onListTypeChange}
						onFiltersClick={this.filtersOpen}
						isLoading={this.state.isLoading}
						listType={this.state.listType}
						orderByField={this.state.orderByField}
						orderBySort={this.state.orderBySort}
						orders={config.orders}
						search={this.state.search}
						searchPlaceholder={config.searchPlaceholder}
						data={this.state.data}
						pagination={this.state.pagination}
						columns={this.columns()}
						showFilters={true}
						filtersCount={this.activeFiltersCount()}
						buttons={[
							{
								visible: this.props.permissions.includes(config.permissionPrefix + ".export"),
								onClick: () => this.fetchGetAll(true, true),
								title  : this.state.isExporting ? "Exportando" : "Exportar",
								icon   : <i className="fal fa-file-export" />,
								loading: this.state.isExporting,
							},
						]}
					/>
				</div>
				<ModalShow
					ref={el => this.showScreen = el}
					visible={this.state.showModalVisible}
					onClose={this.showOnClose}
				/>
				<ModalFilters
					ref={el => this.filtersScreen = el}
					visible={this.state.filtersModalVisible}
					options={this.state.filterOptions}
					onComplete={this.filtersOnComplete}
					onClose={this.filtersOnClose}
				/>
			</QueueAnim>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		permissions: state.auth.userData.permissions,
		listType   : state.general.listType[config.list],
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onChangeListType: (type) => {
			dispatch(generalActions.changeListType(config.list, type));
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
